import React, { useEffect, useState } from "react";
import BreadCrumb from "common/breadcrumb";

import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";

import { BrandingData } from "admin-portal/settings/branding";
import { useLocation } from "react-router-dom";

import { AppDispatch } from "slices/store";
import { useAppSelector, useAppDispatch } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";

import { Job } from "../../models/job/job";
import { Referrer } from "../../models/referrer/referrer";

import AddEditReferrerComponent from "./add-referrer";
import SearchReferrerComponent from "./search-referrer";

const ReferrerPage = () => {
  const dispatch: AppDispatch = useAppDispatch();
  const { loggedInuser } = useAppSelector(getAuthState);

  // Retrieve query parameters
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const referrerId = searchParams.get("id");

  const [loading, setLoading] = useState(false);
  const [addedReferrer, setAddedReferrer] = useState<Referrer>();
  const [editedReferrer, setEditedReferrer] = useState<Referrer>({
    id: referrerId || undefined,
    code: "",
    name: "",
    contactNumber: "",
    email: "",
    isActive: true,
    nic: "",
    vehicles: [],
    jobs: [],
  });
  const [activeTab, setActiveTab] = React.useState<string>("tab-referrers");

  const [reloadReferrer, setReloadReferrer] = useState(0);

  // Effect to set the default tab based on the presence of customerId
  useEffect(() => {
    if (referrerId) {
      setActiveTab("tab-edit-referrer");
    }
  }, [referrerId]);

  const handleTabSelect = (eventKey: string | null) => {
    if (eventKey === "tab-add-referrer" || eventKey === "tab-edit-referrer") {
      // This is where you can force Component to refresh data
      // For example, you can set a state that triggers a refresh
      // setVehicle((prev) => ({ ...prev, refresh: true }));
    }
    setActiveTab(eventKey || "tab-referrer");
  };

  const onReferrerSave = (c: Referrer) => {
    setEditedReferrer({
      id: undefined,
      code: "",
      name: "",
      contactNumber: "",
      email: "",
      isActive: true,
      nic: "",
      vehicles: [],
      jobs: [],
    });
    setAddedReferrer({ ...c });
    setReloadReferrer(reloadReferrer + 1);
    setActiveTab("tab-referrers");
  };
  const onReferrerEditClick = (c: Referrer) => {
    setEditedReferrer({ ...c });
    setActiveTab("tab-add-referrer");
  };

  const tenantId = loggedInuser?.activeTenantId;

  return (
    <React.Fragment>
      <BreadCrumb title={"Referrers"} pageTitle={"Manage"} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <Tab.Container defaultActiveKey={activeTab} onTabChange={handleTabSelect} activeTabKey={activeTab}>
                <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                  <Nav.Item eventKey="tab-referrers" className="group">
                    <a
                      /*   href={`#${RoutePath.Admin_TenantEdit}`} */
                      data-tab-toggle
                      data-target="tab-referrers"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      Search
                    </a>
                  </Nav.Item>
                  {
                    <Nav.Item eventKey="tab-add-referrer" className="group">
                      <a
                        data-tab-toggle
                        data-target="tab-add-referrer"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        {editedReferrer?.id != null ? "Edit" : "Add"} Referrer
                      </a>
                    </Nav.Item>
                  }
                </Nav>

                <Tab.Content className="mt-5 tab-content">
                  <Tab.Pane eventKey="tab-referrers" id="tab-referrers">
                    <div className="mb-0">
                      <SearchReferrerComponent
                        onReferrerEditClick={onReferrerEditClick}
                        reload={reloadReferrer}
                      ></SearchReferrerComponent>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="tab-add-referrer" id="tab-add-referrer">
                    <div className="mb-0">
                      <AddEditReferrerComponent
                        referrer={editedReferrer}
                        onReferrerSaveSuccess={onReferrerSave}
                      ></AddEditReferrerComponent>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReferrerPage;
